export const challengeOptions = {
  Operations: {
    id: "operations",
    name: "Operations",
    icon: "⚙️",
  },
  Sales: {
    id: "sales",
    name: "Sales",
    icon: "💰",
  },
  Marketing: {
    id: "marketing",
    name: "Marketing",
    icon: "📢",
  },
  Product: {
    id: "product",
    name: "Product",
    icon: "📦",
  },
};

export const CHALLENGE_STATUS = {
  NEW: 'new',
  DRAFT: 'draft',
  ACTIVE: 'active',
  ARCHIVED: 'archived'
};

export const ACTIONS = {
  // Challenge Instance Management
  SET_CHALLENGES: 'SET_CHALLENGES',
  ADD_CHALLENGE_INSTANCE: 'ADD_CHALLENGE_INSTANCE',
  UPDATE_CHALLENGE_INSTANCE: 'UPDATE_CHALLENGE_INSTANCE',
  DELETE_CHALLENGE_INSTANCE: 'DELETE_CHALLENGE_INSTANCE',
  ARCHIVE_CHALLENGE_INSTANCE: 'ARCHIVE_CHALLENGE_INSTANCE',

  // Category Management
  ATTACH_CATEGORY: 'ATTACH_CATEGORY',
  DETACH_CATEGORY: 'DETACH_CATEGORY',

  // Challenge Draft Management
  ADD_CHALLENGE_DRAFT: 'ADD_CHALLENGE_DRAFT',
  DELETE_CHALLENGE_DRAFT: 'DELETE_CHALLENGE_DRAFT',
  ATTACH_CHALLENGE: 'ATTACH_CHALLENGE',
  DETACH_CHALLENGE: 'DETACH_CHALLENGE',

  // Opportunity Management
  ADD_DRAFT_OPPORTUNITY: 'ADD_DRAFT_OPPORTUNITY',
  UPDATE_DRAFT_OPPORTUNITY: 'UPDATE_DRAFT_OPPORTUNITY',
  DELETE_DRAFT_OPPORTUNITY: 'DELETE_DRAFT_OPPORTUNITY',
  ACTIVATE_DRAFT_OPPORTUNITY: 'ACTIVATE_DRAFT_OPPORTUNITY',

  // Risk Management
  ADD_DRAFT_RISK: 'ADD_DRAFT_RISK',
  UPDATE_DRAFT_RISK: 'UPDATE_DRAFT_RISK',
  DELETE_DRAFT_RISK: 'DELETE_DRAFT_RISK',
  ACTIVATE_DRAFT_RISK: 'ACTIVATE_DRAFT_RISK',

  // Action Management
  ADD_DRAFT_ACTION: 'ADD_DRAFT_ACTION',
  UPDATE_DRAFT_ACTION: 'UPDATE_DRAFT_ACTION',
  DELETE_DRAFT_ACTION: 'DELETE_DRAFT_ACTION',

  // Active Item Type
  SET_ACTIVE_ITEM_TYPE: 'SET_ACTIVE_ITEM_TYPE'
};

export const initialOppRisk = {
  id: null,
  content: '',
  actions: [],
  isActive: false
};